module.exports = __webpack_public_path__ + "media/images/presta_busc/fonoaudiologo-1d9ffff1a7b9c2863cbfded439bc1ca3.svg";